import { render, staticRenderFns } from "./proofCanvas.vue?vue&type=template&id=34741c5a&"
import script from "./proofCanvas.vue?vue&type=script&lang=js&"
export * from "./proofCanvas.vue?vue&type=script&lang=js&"
import style0 from "./proofCanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports